import React from 'react';

import { DefaultView, EditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { MaxFileSizeConfigEditView } from './views/MaxFileSizeConfigEditView';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContentParagraph } from '../../_lib/components/ContentParagraph';

type MaxFileSizeSettings = BlockWithViews<DefaultView<{ value: string }> & EditView<any>>;
function MaxFileSizeSettings({ views, activeView }: MaxFileSizeSettings) {
  const { t } = useSonTranslation('MaxFileSizeConfig');
  const { uuid, elementType } = useBlockContext();

  const headline = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `MaxFileSizeConfig:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <MaxFileSizeConfigEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <div className="single-input-block">
        <ContentParagraph>{views.default.embedded.value} MB</ContentParagraph>
      </div>
    </BlockInteractions>
  );
}

export const MaxFileSizeConfigBlock = asFetchableBlock(MaxFileSizeSettings, BlockType.maxFileSizeConfig);
